import { Dashboard } from '../types'

export const UPGRADED_DASHBOARD_ROWS = 24
export const UPGRADED_DASHBOARD_COLUMNS = 48

export const isDashboardUpgraded = (
  dashboard: Dashboard | null | undefined,
): boolean => dashboard?.columns === UPGRADED_DASHBOARD_COLUMNS
